import { render, staticRenderFns } from "./FourMatText3.vue?vue&type=template&id=5903a4aa&scoped=true&"
var script = {}
import style0 from "./FourMatText3.vue?vue&type=style&index=0&id=5903a4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903a4aa",
  null
  
)

export default component.exports